export type Possible<T> = T | undefined;
export type Nullable<T> = T | null;
export type Maybe<T> = Possible<T> | Nullable<T>;

export type Loadable<T> = T & { loading?: boolean };

export type KeysOfType<T, U> = Exclude<
  {
    [P in keyof T]: T[P] extends U ? P : never;
  }[keyof T],
  undefined
>;

export type PrimitiveType = boolean & number & string;

export type Without<T, U> = { [P in Exclude<keyof T, keyof U>]?: never };
export type XOR<T, U> = T | U extends object ? (Without<T, U> & U) | (Without<U, T> & T) : T | U;

export type Comparator<T> = (item1: T, item2: T) => number;

export type Filter<T> = (collection: T[]) => T[];

/**
 * Abstracts the logic of keeping track whether content is already loaded or not.
 */
export class LoadableList<T> {
  // tslint:disable-next-line: variable-name
  private _loaded = false;
  // tslint:disable-next-line: variable-name
  private _content: T[] = [];

  constructor(content?: T[]) {
    if (content) {
      this.content = content;
    }
  }

  public get content(): T[] {
    // if (!this._loaded) {
    //    throw new Error(`content not loaded yet.`);
    // }
    return this._content;
  }

  public set content(content: T[]) {
    this._loaded = true;
    this._content = content;
  }

  public get loaded(): boolean {
    return this._loaded;
  }

  /**
   *
   * @param hard If true, content will also be cleared. default:false
   */
  public invalidate(hard = false) {
    this._loaded = false;
    if (hard) {
      this._content = [];
    }
  }
}
